import { useState } from "react";

import {
  Product,
  ProductActionsWrapper,
  ProductImage,
  ProductImageWrap,
} from "../styles/product";

import { useDispatch, useSelector } from "react-redux";

import "../App.css";

import {
  addFavorite,
  removeFavorite,
} from "../features/favoritesSlice";

import ProductVariationPicker from "./ProductVariationPicker";
import ProductName from "./ProductName";
import ProductPrice from "./ProductPrice";
import DealBadge from "./DealBadge";
import ProductButtons from "./ProductButtons";
import {
  Box,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";


export default function SingleProductDesktop({
  width,
  product,
  matches,
}) {
  const theme = useTheme();

  const isMobile = useMediaQuery(
    theme.breakpoints.down("sm")
  );
  const [showOptions, setShowOptions] = useState(false);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [selectedVariations, setSelectedVariations] =
    useState({});

  const dispatch = useDispatch();

  const favorites = useSelector(
    (state) => state.favorites
  );

  const isFavorite = favorites.some(
    (favorite) => favorite.id === product.id
  );


  const handleMouseEnter = () => {
    setShowOptions(true);
  };


  const handleMouseLeave = () => {
    setShowOptions(false);
  };


  const handleAddToFavorites = () => {
    if (isFavorite) {
      dispatch(removeFavorite(product));
    } else {
      dispatch(addFavorite(product));
    }
  };


  /*
   * בדיקת המלאי של המוצר הראשי.
   *
   * המוצר ייחשב כלא במלאי כאשר:
   * 1. המנהל סימן isInStock כ-false.
   * 2. הכמות של המוצר היא 0.
   */
  const isProductOutOfStock =
    product?.isInStock === false ||
    product?.IsInStock === false


  /*
   * הווריאציה שנבחרה.
   *
   * בדרך כלל תהיה בחירת צבע או בחירת מידה.
   */
  const selectedVariation =
    selectedVariations?.Color ||
    selectedVariations?.Size ||
    null;


  /*
   * בדיקת המלאי של הווריאציה שנבחרה.
   */
  const isSelectedVariationOutOfStock =
    Boolean(selectedVariation) &&
    (
      selectedVariation?.isInStock === false ||
      selectedVariation?.IsInStock === false
    );


  /*
   * המוצר לא זמין לרכישה כאשר:
   * - המוצר הראשי לא במלאי.
   * - או שהווריאציה שנבחרה לא במלאי.
   */
  const isOutOfStock =
    isProductOutOfStock ||
    isSelectedVariationOutOfStock;


  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";


  const resolveImgSrc = (image) => {
    if (!image) {
      return null;
    }

    if (image instanceof File) {
      return URL.createObjectURL(image);
    }

    const path = String(image).replace(/\\/g, "/");

    if (
      path.startsWith("http") ||
      path.startsWith("//")
    ) {
      return path;
    }

    return `${API_BASE}${path}`;
  };


  const basePrice =
    Number(product?.price) || 0;


  const selectedExtra =
    Number(
      selectedVariations?.Color?.extraPrice ??
      selectedVariations?.Size?.extraPrice ??
      0
    ) || 0;


  const displayPrice =
    selectedExtra > 0
      ? selectedExtra
      : basePrice;


  const selectedImage =
    selectedVariations?.Color?.image ||
    selectedVariations?.Size?.image ||
    product?.image;


  return (
    <>
      <Product
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          position: "relative",
          width: "100%",

          minWidth: 0,

          height: {
            xs: 420,
            sm: 440,
            md: 420,
          },

          padding: {
            xs: "8px",
            sm: "12px",
            md: "16px",
          },
          boxSizing: "border-box",
        }}
      >
        <DealBadge product={product} />

        <ProductImageWrap
          role="button"
          tabIndex={0}
          aria-label={`הגדלת התמונה של ${product?.name || "המוצר"}`}
          onClick={() => setIsImageOpen(true)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setIsImageOpen(true);
            }
          }}
          sx={{
            position: "relative",
            cursor: "zoom-in",
            width: "100%",
            aspectRatio: "1 / 1",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            "&:hover .zoom-icon": {
              opacity: 1,
            },
          }}
        >
          <ProductImage
            src={resolveImgSrc(selectedImage)}
            alt={product?.name || "מוצר"}
            sx={{
              display: "block",
              width: "100%",
              height: "100%",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />

         <ZoomInIcon
  className="zoom-icon"
  aria-hidden="true"
  sx={{
    display: {
      xs: "none",
      md: "block",
    },

    position: "absolute",
    bottom: 8,
    left: 8,
    borderRadius: "50%",
    color: "#ffffff",
    backgroundColor: "rgba(0, 0, 0, 0.55)",

    width: 34,
    height: 34,
    padding: "6px",

    opacity: 0,
    transition: "opacity 0.2s ease",
    pointerEvents: "none",
  }}
/>
        </ProductImageWrap>

        <ProductName
          product={product}
          matches={matches}
        />

        <ProductVariationPicker
          productId={product.id}
          onChange={setSelectedVariations}
        />

        <ProductPrice
          price={displayPrice}
          matches={matches}
        />

        {isOutOfStock && (
          <Typography
            variant="h6"
            color="error"
            sx={{
              mt: 1,
              mb: 1,
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            לא במלאי
          </Typography>
        )}

        <ProductActionsWrapper
          data-show={showOptions || matches}
        />

        <ProductButtons
          product={product}
          selectedVariations={selectedVariations}
          isOutOfStock={isOutOfStock}
        />
      </Product>
      <Dialog
        open={isImageOpen}
        onClose={() => setIsImageOpen(false)}
        fullScreen={isMobile}
        maxWidth="lg"
        fullWidth
        aria-labelledby="product-image-dialog-title"
        BackdropProps={{
          sx: {
            top: {
              xs: 0,
              sm: "90px",
              md: "115px",
            },
          },
        }}
        sx={{
          top: {
            xs: 0,
            sm: "90px",
            md: "115px",
          },

          "& .MuiDialog-container": {
            alignItems: "center",
          },

          "& .zoomed-product-image": {
            maxHeight: {
              xs: "100dvh",
              sm: "calc(100vh - 125px)",
              md: "calc(100vh - 150px)",
            },
          },
        }}
        PaperProps={{
          sx: {
            position: "relative",

            m: {
              xs: 0,
              sm: 2,
            },

            maxHeight: {
              xs: "100dvh",
              sm: "calc(100vh - 110px)",
              md: "calc(100vh - 135px)",
            },

            backgroundColor: "#ffffff",
            overflow: "hidden",
          },
        }}
      >
        <Typography
          id="product-image-dialog-title"
          component="h2"
          sx={{
            position: "absolute",
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            border: 0,
          }}
        >
          תמונה מוגדלת של{" "}
          {product?.name || "המוצר"}
        </Typography>

        <IconButton
          onClick={() => setIsImageOpen(false)}
          aria-label="סגירת התמונה המוגדלת"
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 2,
            color: "#ffffff",
            backgroundColor: "rgba(0, 0, 0, 0.6)",

            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          component="img"
          className="zoomed-product-image"
          src={resolveImgSrc(selectedImage)}
          alt={product?.name || "מוצר"}
          sx={{
            display: "block",
            width: "100%",
            height: "auto",
            objectFit: "contain",
            margin: "0 auto",
          }}
        />
      </Dialog>
    </>
  );
}